import React, { useEffect, useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

const GeneralButton = (props: UIProperties<GeneralButtonConfig>) => {
	const [isOver, setIsOver] = useState(false);
	const [forceHighlight, setforceHighlight] = useState(false);
	if(props.parameters.onForceHighlight) {
		props.parameters.onForceHighlight((shouldForce: boolean) => {
			setforceHighlight(shouldForce);
		});
	}
	
	useEffect(() => {

	}, [isOver])

	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: props.parameters.top,
			left: props.parameters.left,
			width: props.parameters.width,
			...props.parameters.customContainerStyle
		}}>
			<button id={props.parameters.id} tabIndex={0} aria-label={props.parameters.ariaLbl} className="pointer" style={{
				position: 'relative',
				background: 'transparent',
				pointerEvents: props.parameters.isDisabled ? 'none' : 'all',
				...props.parameters.customBttnStyle
			}} onMouseOver={() => {
				if(props.parameters.highlightOnHover) {
					setIsOver(true);
				}
			}} onMouseDown={() => {
				setIsOver(true);
			}} onMouseUp={() => {
				setIsOver(false);
			}} onMouseOut={() => {
				setIsOver(false);
			}}
			aria-disabled={props.parameters.isDisabled}
			onClick={() => {
				if(props.parameters.isDisabled) {
					return
				}
				if(props.parameters.onClicked) {
					props.parameters.onClicked();
				}
			}}>
				<img style={{
					pointerEvents: 'none',
					...props.parameters.customImgStyle
				}} src={props.parameters.srcIdle} />
				{isOver || props.parameters.shouldLeaveOn || forceHighlight ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					pointerEvents: 'none',
					...props.parameters.customImgStyle
				}} src={props.parameters.srcHighlight} />) : (<div></div>)}
				{props.parameters.isDisabled ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					pointerEvents: 'none',
					...props.parameters.customImgStyle
				}} src={props.parameters.srcDisabled} />) : (<div></div>)}
			</button>
		</div>
	);

};

export interface GeneralButtonConfig extends BaseConfig{
	srcIdle: string;
	id?: string;
	srcHighlight: string;
	srcDisabled?: string;
	isDisabled?: boolean;
	top: string;
	left: string;
	width: string;
	shouldLeaveOn?: boolean;
	highlightOnHover?: boolean;
	customImgStyle? : any;
	customBttnStyle?: any;
	customContainerStyle?: any;
	ariaLbl?: string;
	onClicked: () => void;
	onForceHighlight?: (forceHighlight: (shouldForce: boolean) => void) => void;
}

export default GeneralButton;